import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { ToastData, ToastType } from '@ld.consumer-portal/models';
import { ToastService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-toast-container',
  imports: [MatIconModule, TranslocoDirective],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);

  protected readonly ToastType = ToastType;

  protected getIcon(type: ToastType): string {
    switch (type) {
      case ToastType.Success:
        return 'check_circle';
      case ToastType.Error:
        return 'error';
      case ToastType.Warning:
        return 'warning';
      case ToastType.Info:
      default:
        return 'info';
    }
  }

  protected getToastClasses(type: ToastType): string {
    switch (type) {
      case ToastType.Success:
        return 'bg-white text-ld-success border-2 border-ld-success shadow-2xl';
      case ToastType.Error:
        return 'bg-white text-ld-error border-2 border-ld-error shadow-2xl';
      case ToastType.Warning:
        return 'bg-white text-ld-warning border-2 border-ld-warning shadow-2xl';
      case ToastType.Info:
      default:
        return 'bg-white text-ld-link border-2 border-ld-link shadow-2xl';
    }
  }

  protected onDismiss(toast: ToastData): void {
    this.toastService.dismiss(toast.id);
  }

  protected onAction(toast: ToastData): void {
    toast.actionCallback?.();
    this.toastService.dismiss(toast.id);
  }
}
